import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import "../../App.css";
import { CookieService } from "../../Service/CookieService";
import Logo from "../Logo/Logo";
import ProfileBar from "../Static/Profile/ProfileBar";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import BackToSuperAdminIcon from "../../assets/images/icons/BackToSuperAdminIcon.svg";
import Constant from "../../Constant";

const Header = () => {
  const cookies = new Cookies();
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const loginAsUser = localStorage.getItem("loginAsUser");
  const profileBarKey = [
    cookies.get("userId") || "guest",
    cookies.get("userRole") || "guest",
    cookies.get("userName") || "guest",
    loginAsUser || "no",
    location.pathname,
  ].join(":");

  const logout = () => {
    CookieService.removeAuthToken();
    history.push("/login");
  };

  const downloadCompanyAndUsers = async () => {
    try {
      const response: any = await Service.getCompanyUsersData();
      // Assuming response.data is the blob data
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "user_company_list.xlsx"; // Specify the download filename
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //     // Initialize Bootstrap components when the component mounts
  //     const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
  //     dropdownElementList.map(function (dropdownToggleEl) {
  //       return new window.bootstrap.Dropdown(dropdownToggleEl);
  //     });
  //   }, []);

  useEffect(() => {
    const fetchUserRole = () => {
      const cookies = new Cookies();
      const role = cookies.get("userRole");
      setUserRole(role);
    };

    const fetchCurrentPath = () => {
      const currentPath = location.pathname;
      console.log(currentPath);
      // Update the activeTab state based on the current pathname
      if (currentPath === "/master/dashboard") {
        setActiveTab("dashboard");
      } else if (currentPath === "/master/user-list") {
        setActiveTab("user-list");
      } else if (currentPath === "/inventories") {
        setActiveTab("inventories");
      } else if (currentPath === "/my-inventory") {
        setActiveTab("my-inventory");
      } else if (currentPath === "/inventory-sell-requests") {
        setActiveTab("inventory-sell-requests");
      } else if (currentPath === "/login-history") {
        setActiveTab("login-history");
      } else if (currentPath.includes("/view-csv")) {
        setActiveTab("view-csv");
      } else if (currentPath.includes("/view-sell-request")) {
        setActiveTab("view-sell-request");
      } else if (currentPath.includes("/my-cart")) {
        setActiveTab("my-cart");
      } else if (currentPath.includes("/message")) {
        setActiveTab("my-cart");
      } else {
        setActiveTab("");
      }
    };

    fetchUserRole();

    fetchCurrentPath();
  }, [location.pathname]);

  function route(route: string) {
    history.push(route);
  }

  const routeBack = () => {
    if (CommonService.isWarehouse()) return "/master/storage-dashboard";
    return "/master/dashboard";
  };

  // Exit impersonation and restore original admin session
  const backToSuperAdmin = async () => {
      try {
        // Get the saved admin token and info
        const adminToken = localStorage.getItem("adminTokenBackup");
        const adminUser = localStorage.getItem("adminUserBackup");
  
        if (!adminToken || !adminUser) {
          console.error("No admin backup found, cannot exit impersonation");
          return;
        }
  
        const adminData = JSON.parse(adminUser);
  
        // Restore cookies
        CookieService.setAuthToken("authToken", adminToken);
        CookieService.setAuthToken("userRole", adminData.role || Constant.Role.SUPER_ADMIN);
        CookieService.setAuthToken("userId", adminData.userId || "");
        CookieService.setAuthToken("userName", adminData.userName || "");
        CookieService.setAuthToken("companyId", adminData.companyId || "");
        CookieService.setAuthToken("companyName", adminData.companyName || "");
  
        // Clean up impersonation storage
        localStorage.removeItem("impersonatedUser");
        localStorage.removeItem("adminTokenBackup");
        localStorage.removeItem("adminUserBackup");
        localStorage.removeItem("loginAsUser");
        localStorage.removeItem("updateUserName");
        localStorage.removeItem("profile");

        // Redirect to admin dashboard
        history.push("/master/dashboard");
  
      } catch (error) {
        console.error("Failed to exit impersonation", error);
      }
  };

  return (
    <header className="wd__header wd__header--user">
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand" to={routeBack()}>
            <Logo size={"200px"} />
          </Link>
          {!CommonService.isWarehouse() && <div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* <div>
            <ProfileBar />
          </div> */}
          {/* <ul className="navbar-nav ms-auto mb-3 mt-2 mt-md-0 mb-md-0">
            <li className="nav-item dropdown ms-1">
              <ProfileBar />
            </li>
          </ul> */}
        </div>}
        {!CommonService.isWarehouse() && 
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/master/dashboard")}
                  role="button"
                  aria-expanded="false"
                >
                  Home
                </a>
                {/* <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="#">Action</a></li>
                <li><a className="dropdown-item" href="#">Another action</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item" href="#">Something else here</a></li>
              </ul> */}
              </li>
              <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span onClick={() => route("/master/inventories")}>
                      Marketplace
                    </span>
                    <ExpandMoreRoundedIcon />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => route("/master/wanted-to-buy")}
                      >
                        Wanted To Buy
                      </a>
                    </li>
                    {/* <li><hr className="dropdown-divider" /></li> */}
                  </ul>
                </li>
              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/master/manage-requests")}
                  role="button"
                  aria-expanded="false"
                >
                  Manage Requests
                </a>
              </li> */}
              {userRole === "SUPER_ADMIN" && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Requests
                    <ExpandMoreRoundedIcon />
                  </a>
                  <ul className="dropdown-menu">
                    {/* <li>
                      <a
                        className="dropdown-item"
                        onClick={() => route("/master/inventory-sell-requests")}
                      >
                        Inventory Sell Requests
                      </a>
                    </li> */}
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => route("/master/active-order")}
                      >
                        Order Requests
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => route("/master/sample-request")}
                      >
                        Sample Requests
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => route("/master/offer-request")}
                      >
                        Offer Requests
                      </a>
                    </li>
                    {/* <li><hr className="dropdown-divider" /></li> */}
                  </ul>
                </li>
              )}

                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Reports
                    <ExpandMoreRoundedIcon />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          history.push("/master/reporting", {
                             reportType: "companyInventorySummary"
                          })
                        }
                      >
                        Inventory Summary
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          history.push("/master/reporting", {
                            reportType: "companyBillingActivity"
                          })
                        }
                      >
                        Billing Activity
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          history.push("/master/reporting", {
                            reportType: "ttbReporting"
                          })
                        }
                      >
                        TTB Reporting
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          history.push("/master/reporting", {
                            reportType: "serviceRequestBilling"
                          })
                        }
                      >
                        Service Request Billing
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() =>
                          history.push("/master/reporting", {
                            reportType: "companyBulkInventoryUpload"
                          })
                        }
                      >
                        Bulk Inventory Upload
                      </a>
                    </li>
                  </ul>
                </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/master/messages")}
                  role="button"
                  aria-expanded="false"
                >
                  Inbox
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/master/login-history")}
                  role="button"
                  aria-expanded="false"
                >
                  Login History
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => route("/master/customer-service")}
                  role="button"
                  aria-expanded="false"
                >
                  Customer Service
                </a>
              </li>

              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  aria-current="page"
                  onClick={() => downloadCompanyAndUsers()}
                  role="button"
                  aria-expanded="false"
                >
                  Export Companies & Users
                </a>
              </li> */}
            </ul>
          </div>}
          {loginAsUser && (
              <div>
                <a
                  className="d-inline-flex justify-content-between align-items-center back_to_admin"
                  href="#"
                  style={{ paddingLeft: 15 }}
                  onClick={backToSuperAdmin}
                >
                  <img src={BackToSuperAdminIcon} alt="back to super admin" />
                  Back to Super Admin
                </a>
              </div>
           )}
        </div>
        <div className="ms-auto me-2 mb-2 mb-lg-0">
          <ProfileBar key={profileBarKey} />
        </div>
      </nav>

      {/* <div>
  
              <div className="logout"> 
                  <Button variant="contained" size="small" onClick={logout}>Logout</Button>
              </div>
          </div> */}
    </header>
  );
};

export default Header;
